module.exports = __webpack_public_path__ + "static/img/3.19d7e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/3.png
// module id = F5nG
// module chunks = 0